var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubitak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.45 136.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #ed1c24;\n      }\n\n      .cls-3, .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.06,121.47c2.69-1.23,4.08-3.53,3.93-6.48-.21-4.1-3.34-7.1-8.53-7.18h-4.88v27.97h5.89c3.87,0,7.9-3.37,7.9-7.67,0-5.42-4.32-6.64-4.32-6.64ZM40.49,112.38c2.01-.07,3.72.76,3.72,3.55s-1.71,3.73-3.72,3.63v-7.18ZM40.49,131.31v-7.46c2.09-.14,3.91,1.49,4,3.58.09,2.17-1.83,4.04-4,3.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 107.81 3.39 107.81 8.29 107.81 11.82 107.81 11.82 112.44 8.29 112.44 8.29 135.77 3.39 135.77 3.39 112.44 0 112.44 0 107.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.27,
    y: 101.11,
    width: 4.18,
    height: 4.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.72,107.81h4.9v21.76c0,1.15.94,2.09,2.09,2.09s2.09-.94,2.09-2.09v-21.76h4.9v21.46c0,3.86-3.13,6.99-6.99,6.99s-6.99-3.13-6.99-6.99v-21.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25,
    y: 101.11,
    width: 4.18,
    height: 4.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.07 107.81 67.47 107.81 72.36 107.81 75.9 107.81 75.9 112.44 72.36 112.44 72.36 135.77 67.47 135.77 67.47 112.44 64.07 112.44 64.07 107.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.28,
    y: 101.11,
    width: 4.9,
    height: 4.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.28,
    y: 107.81,
    width: 4.9,
    height: 27.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "105.94 107.81 111.45 107.8 106.65 119.56 106.57 119.68 111.45 135.85 105.89 135.77 102.88 125.47 101.85 128.24 101.85 135.77 96.95 135.77 96.95 107.81 101.85 107.81 101.85 119.3 105.94 107.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.58,107.81h-4.58l-5.63,27.97h4.64l.97-5.49h4.62l.97,5.49h4.64l-5.63-27.97ZM83.76,125.84l1.53-8.69,1.53,8.69h-3.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.99,27.97h-2.36c0,3.08-.78,5.97-2.14,8.5.46.84.84,1.73,1.16,2.65,2.11-3.2,3.34-7.03,3.34-11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.96,36.47c-1.37-2.53-2.14-5.42-2.14-8.5h-2.36c0,4.12,1.23,7.95,3.34,11.14.32-.92.71-1.8,1.16-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.44,47.55c5.33-4.83,8.68-11.81,8.68-19.57h-3.46c0,5.52-1.95,10.59-5.2,14.55.11.8.17,1.62.17,2.45,0,.88-.07,1.74-.19,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.01,47.54c-.12-.84-.19-1.7-.19-2.58,0-.83.06-1.65.17-2.45-3.25-3.96-5.2-9.02-5.2-14.55h-3.46c0,7.76,3.35,14.74,8.68,19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.7,27.97c0,8.98-4.23,16.97-10.81,22.09-2.2,7.41-9.05,12.81-17.16,12.81s-14.97-5.4-17.16-12.81c-6.58-5.12-10.81-13.11-10.81-22.09H9.08l46.64,65.1L102.36,27.97h-18.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.75,27.97C27.75,12.52,40.27,0,55.72,0s27.97,12.52,27.97,27.97h-1.57c0-14.58-11.82-26.4-26.4-26.4s-26.4,11.82-26.4,26.4h-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.79,27.97c0-12.67,10.27-22.94,22.94-22.94s22.94,10.27,22.94,22.94h-2.67c0-11.19-9.07-20.26-20.26-20.26s-20.26,9.07-20.26,20.26h-2.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M55.72,48.24c-7.07,0-13.3-3.63-16.93-9.12-.38,1.09-.65,2.23-.81,3.4,4.21,5.12,10.59,8.39,17.74,8.39s13.53-3.27,17.74-8.39c-.16-1.17-.43-2.31-.81-3.4-3.62,5.49-9.85,9.12-16.93,9.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.96,36.47c3.03,5.6,8.95,9.41,15.76,9.41s12.74-3.81,15.76-9.41c-2.15-3.98-5.76-7.05-10.11-8.5h12.25c0-9.89-8.02-17.9-17.9-17.9s-17.9,8.02-17.9,17.9h12.25c-4.35,1.45-7.96,4.52-10.11,8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,47.54c.12.86.31,1.7.55,2.52,4.74,3.69,10.7,5.89,17.17,5.89s12.43-2.2,17.17-5.89c.24-.82.43-1.66.55-2.52-4.68,4.24-10.9,6.83-17.72,6.83s-13.04-2.59-17.72-6.83Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubitak);
export default __webpack_public_path__ + "static/media/tubitak.35ebd88a086df888f6f124b1dc09f34d.svg";
export { ForwardRef as ReactComponent };